export default "__VITE_ASSET__Bk7O7$Fm__"